.create-event-form
  h3 Neues Event erstellen
  form.pure-form.pure-form-stacked
    input(name="name", type="text", placeholder="Name", autofocus, autocomplete="off")
    button(type="submit", disabled).pure-button.pure-button-primary Event erstellen
